import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "fs-6" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "mx-1" }
const _hoisted_5 = { class: "h6 fw-bold mb-0" }
const _hoisted_6 = { class: "list-unstyled list-inline d-flex justify-content-between mx-1" }
const _hoisted_7 = { class: "list-inline-item" }
const _hoisted_8 = { class: "list-inline-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["list-inline-item small text-wrap mx-2", { 'current-video': _ctx.current }])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        role: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectVideo(_ctx.index)))
      }, [
        _createElementVNode("img", {
          src: _ctx.video.thumbnail,
          class: "img-fluid d-block"
        }, null, 8, _hoisted_1),
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "far fa-play-circle fa-7x" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          checked: _ctx.watched,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleWatchedVideo(_ctx.video.videoId)))
        }, null, 40, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.video.title), 1)
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _createElementVNode("li", _hoisted_7, [
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "me-2 far fa-user-circle" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.video.speaker), 1)
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.video.duration), 1),
        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ms-1 far fa-clock" }, null, -1))
      ])
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.video.description), 1)
  ], 2))
}